import type { ComponentType } from 'react';
import { Stack } from '@mui/material';
import { FilterCheckbox } from './filter-checkbox';
import { FilterDivider } from './filter-divider';
import { FilterInlineSelect } from './filter-inline-select';
import { FilterLocation } from './filter-location';
import { FilterPrice } from './filter-price';
import { FilterSelect } from './filter-select';
import { FilterSwitch } from './filter-switch';
import { FilterTagCloud } from './filter-tag-cloud';
import { FilterText } from './filter-text';
import { useCatalogFilters } from '@/packages/courses/context/catalog-filters';
import type { FilterSchemaItem } from '@/packages/courses/types/schema';

type FilterComponentsMap = {
  [K in FilterSchemaItem['type']]: ComponentType<
    Extract<FilterSchemaItem, { type: K }>
  > | null;
};

const componentsByType: FilterComponentsMap = {
  checkbox: FilterCheckbox,
  select: FilterSelect,
  inlineSelect: FilterInlineSelect,
  text: FilterText,
  location: FilterLocation,
  price: FilterPrice,
  switch: FilterSwitch,
  tagCloud: FilterTagCloud,
  divider: FilterDivider,
};

export const CatalogFiltersList = () => {
  const { schema } = useCatalogFilters();

  return (
    <Stack spacing={3}>
      {schema.map((item) => {
        const Component = componentsByType[item.type] as ComponentType<FilterSchemaItem> | null;
        if (!Component) return null;
        return <Component key={item.id} {...item} />;
      })}
    </Stack>
  );
};

export {
  FilterCheckbox,
  FilterDivider,
  FilterInlineSelect,
  FilterLocation,
  FilterPrice,
  FilterSelect,
  FilterSwitch,
  FilterTagCloud,
  FilterText,
};
